import { BASE_INFO_FIELD_KEY_LIST } from '../../capabilities/base-info/fieldKeys';
import { ENV_VARS_FIELD_KEY_LIST } from '../../capabilities/env-vars/fieldKeys';
import { HEALTH_CHECK_FIELD_KEY_LIST } from '../../capabilities/health-check/fieldKeys';
import { MAAS_COMMAND_ARGS_NORMAL_FIELD_KEY_LIST } from '../../capabilities/maas-command-args-normal/fieldKeys';
import { MAAS_IMAGE_STORAGE_FIELD_KEY_LIST } from '../../capabilities/maas-image-storage/fieldKeys';
import { MAAS_MODEL_STORAGE_FIELD_KEY_LIST } from '../../capabilities/maas-model-storage/fieldKeys';
import { MAAS_GATEWAY_NODES_FIELD_KEY_LIST, MAAS_NODE_GROUPS_FIELD_KEY_LIST } from '../../capabilities/maas-node-groups/fieldKeys';
import { MAAS_SYSTEM_CONFIG_FIELD_KEY_LIST } from '../../capabilities/maas-system-config/fieldKeys';
import { MAAS_TASK_TEMPLATE_FIELD_KEY_LIST } from '../../capabilities/maas-task-template/fieldKeys';
import { RUNTIME_CONFIG_FIELD_KEY_LIST } from '../../capabilities/runtime-config/fieldKeys';
import { SERVICE_FIELD_KEY_LIST } from '../../capabilities/service/fieldKeys';

export const MI_FIELD_KEYS = [
  ...BASE_INFO_FIELD_KEY_LIST,
  ...RUNTIME_CONFIG_FIELD_KEY_LIST,
  ...MAAS_MODEL_STORAGE_FIELD_KEY_LIST,
  ...MAAS_SYSTEM_CONFIG_FIELD_KEY_LIST,
  ...SERVICE_FIELD_KEY_LIST,
  ...ENV_VARS_FIELD_KEY_LIST,
  ...MAAS_IMAGE_STORAGE_FIELD_KEY_LIST,
  ...MAAS_NODE_GROUPS_FIELD_KEY_LIST,
  ...MAAS_GATEWAY_NODES_FIELD_KEY_LIST,
  ...MAAS_COMMAND_ARGS_NORMAL_FIELD_KEY_LIST,
  ...MAAS_TASK_TEMPLATE_FIELD_KEY_LIST,
  ...HEALTH_CHECK_FIELD_KEY_LIST,
  'mi.network.nics',
  'mi.network.nicPricing',
] as const;

export type MiFieldKey = (typeof MI_FIELD_KEYS)[number];
